// A tiny page-local event bus: anything that queues work (an analysis, a
// generation, a retry) calls bumpStaticActivity(), and the global status strip
// starts polling until the backend reports everything settled. No context
// plumbing — the queue sites and the strip live in separate component trees.

type Listener = () => void;

const listeners = new Set<Listener>();

export function bumpStaticActivity(): void {
  listeners.forEach(l => l());
}

export function onStaticActivityBump(listener: Listener): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
